import { mapMutations, mapActions, mapState } from "vuex";
import { getCookie } from "./helpers/helpers";
import axios from 'axios';

export default {
    data() {
        return {};
    },
    computed: {
        ...mapState('token', [
            'tokens',
            'loading',
        ]),
    },
    methods: {
        ...mapMutations('token', ['setTokens', 'logout']),
        ...mapActions('token', ['requestUpdateToken']),
        ...mapActions('user', ['requestUser']),
        async retriveTokens() {
            const access = getCookie('tokenAccess');
            const refresh = getCookie('tokenRefresh');
            this.setTokens({ access, refresh });
            
             if (this.tokens.refresh && !this.tokens.access) {
                await this.requestUpdateToken();
            }
        },
        requestInterceptor() {
            axios.interceptors.request.use(config => {
                const access = getCookie('tokenAccess');
                const refresh = getCookie('tokenRefresh');
                this.setTokens({ access, refresh });
                
                const urlNeedToken = config.url.indexOf('login') === -1 && config.url.indexOf('refresh') === -1;
                
                if (!urlNeedToken) {
                    return config;
                } else if (this.loading) {
                    return (new Promise((resolve, reject) => {
                        const interval = setInterval(()=> {
                            if (this.tokens.access) {
                                resolve(this.tokens.access);
                                clearInterval(interval);
                            }
                        }, 100);
                    })).then(tokenAccess => {
                        config.headers.Authorization = `JWT ${this.tokens.access}`;
                        return Promise.resolve(config);
                    });
                }
                else if (!this.tokens.access && this.tokens.refresh) {
                    return this.requestUpdateToken().then(response => {
                        config.headers.Authorization = `JWT ${this.tokens.access}`;
                        return Promise.resolve(config);
                    }).catch(error => {
                        this.logout();
                        console.log(this.$route.name);
                        if (this.$route.name !== 'Login') { this.$router.push('/entrar'); }
                        return Promise.resolve(config);
                    });
                } else {
                    config.headers.Authorization = `JWT ${this.tokens.access}`;
                    return config;
                }
            }, (error)=> (Promise.reject(error)));
        },
        responseInterceptor() {
            axios.interceptors.response.use(response=> (response), error=> {
                if ( error.response && (error.response.status === 403 || error.response.status === 401) ) {
                    this.logout();
                    if (this.$route.name !== 'Login') { this.$router.push('/entrar'); }
                }
                return Promise.reject(error);
            });
        },
        preventInstallEvent() {
            window.addEventListener('beforeinstallprompt', event => {
                event.preventDefault();
            });
        },
        redirect() {
            console.log('aqui')
            //window.location.href = "https://azhoteis.com.br/entrar"
            //this.$router.push('/entrar')
            //this.$router.push('/redirect')
            return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
            console.log(window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true)
        },
        isPWA() {
            
            var pwa = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
            console.log('pwa ' + pwa)
            console.log('route ' + this.$route.name)
            if (pwa === true) {
                if (this.$route.name !== 'Login') {
                    console.log('Redirecionando para login');
                    this.$router.push('/entrar');
                }
            } else {
                if (this.$route.name !== 'Login') {
                    console.log('Redirecionando para o site principal');
                    window.location.href = "https://www.ninety.com.br/";
                }
            }


            //return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

          },
    },
    async created() {   
        this.isPWA();
        this.preventInstallEvent();
        this.requestInterceptor();
        this.responseInterceptor();
    }
}
